"use client";

import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

import { isBurgerActiveContext } from "@/context/is-burger-active";
import { MobileContextValue } from "@/TS/Interfaces/global_interfaces";

export const MobileContext = createContext<MobileContextValue>(null!);

function MobileProvider({ children }: { children: ReactNode }) {
  const [isActive, setIsActive] = useContext(isBurgerActiveContext);
  const [isPublic, setIsPublic] = useState<boolean>(false);

  useEffect(() => {
    if (!isPublic) {
      setIsActive(false);
    }
  }, [isActive, isPublic, setIsActive]);

  return (
    <MobileContext.Provider value={{ isPublic, setIsPublic }}>
      {children}
    </MobileContext.Provider>
  );
}

export default MobileProvider;
